import { useCallback, useContext } from 'react';
import { useLocation } from 'react-router';

import { ConfigContext } from 'Context/config';
import { VehicleLookupContext } from 'Context/vehicleLookup';

import { getSnowplowIds } from 'Utilities/analytics';

export const clientId = 'seller-web-app';

export const useAuthorize = () => {
  const location = useLocation();
  const { configState: { authnApi } } = useContext(ConfigContext);
  const { vehicleLookupState: vehicle } = useContext(VehicleLookupContext);
  const vrm = vehicle?.vrm ?? '';
  const brand = vehicle?.make?.display_name ?? '';
  const authApi = authnApi ?? 'https://auth.motorway.co.uk';

  const getRedirectUri = useCallback(() => {
    const searchParams = new URLSearchParams(location.search);
    const redirectParam = searchParams.get('redirect');
    const origin = globalThis?.location?.origin ?? 'https://motorway.co.uk';
    const excludedPathNames = ['/sign-in'];
    const updatedPathname = excludedPathNames.includes(location.pathname) ? '/' : location.pathname;

    if (redirectParam) {
      const fullRedirectUrlWithRedirectParam = new URL(redirectParam, origin);
      return fullRedirectUrlWithRedirectParam?.toString()?.trim();
    }

    const buildParams = new URLSearchParams();
    if (vehicle?.enquiry?.mileage) {
      buildParams.set('mileage', vehicle.enquiry.mileage?.toString());
    }

    const fullRedirectUrl = `${origin}${updatedPathname}?${buildParams.toString()}`?.toString()?.trim();
    return fullRedirectUrl;
  }, [location.pathname, location.search, vehicle?.enquiry?.mileage]);

  const getAuthorizeUrl = useCallback((isTokenExpired = false) => {
    const redirectUri = getRedirectUri();

    const params = new URLSearchParams({
      brand,
      clientId,
      redirectUri,
      responseType: 'code',
      vrm,
      xSpId: getSnowplowIds()?.snowplowSessionId ?? '',
      ...(isTokenExpired && { error: 'expired' }),
    });

    return `${authApi}/oauth2/authorize?${params.toString()}`;
  }, [authApi, brand, getRedirectUri, vrm]);

  return { getAuthorizeUrl };
};
